<template>
  <ten-popup
    v-bind="$attrs"
    type="bubble"
    :show="popupShowed"
    :popup-class="_popupClass"
    @change="onPopupShowChange"
  >
    <template v-slot:trigger>
      <!-- @slot 触发元素，必须是一个元素或者或者组件 -->
      <slot />
    </template>

    <div class="ten-popconfirm__content ten-popover__content">
      <div class="ten-popconfirm__title">
        <!-- @slot 自定义 title，title 包含 icon -->
        <slot name="title">
          <ten-icon
            class="ten-popconfirm__title-icon"
            :icon="icon"
            :style="_iconStyle"
            v-if="icon"
          />
          {{ title }}
        </slot>
      </div>

      <div class="ten-popconfirm__buttons">
        <ten-button
          class="ten-popconfirm__cancel"
          size="small"
          v-if="cancelText"
          @click="onCancel"
        >
          {{ cancelText }}
        </ten-button>
        <ten-button
          class="ten-popconfirm__confirm"
          type="primary"
          size="small"
          v-if="confirmText"
          @click="onConfirm"
        >
          {{ confirmText }}
        </ten-button>
      </div>
    </div>
  </ten-popup>
</template>
<script>
import TenIcon from '../icon';
import TenButton from '../button';

export default {
  name: 'TenPopconfirm',
  components: {
    TenIcon,
    TenButton,
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    /**
     * 确认框 title
     */
    title: String,
    /**
     * 确认按钮文字
     */
    confirmText: {
      type: String,
      default: '确认',
    },
    /**
     * 取消按钮文字
     */
    cancelText: {
      type: String,
      default: '取消',
    },
    /**
     * 确认框 icon
     */
    icon: {
      type: [String, Boolean],
      default: 'circle_error',
    },
    /**
     * 确认框 icon 颜色
     */
    iconColor: String,
    /**
     * 弹窗是否可见
     */
    show: Boolean,
    /**
     * 弹窗 class
     */
    popupClass: [String, Object, Array],
  },
  data() {
    return {
      popupShowed: false,
    };
  },
  computed: {
    _popupClass() {
      return ['ten-popconfirm', this.popupClass || ''];
    },
    _iconStyle() {
      return this.iconColor ? { color: this.iconColor } : {};
    },
  },
  watch: {
    show: {
      handler(v) {
        this.popupShowed = v;
      },
      immediate: true,
    },
  },
  methods: {
    onConfirm() {
      /**
       * 确定事件
       * @event confirm
       */
      this.$emit('confirm');
      this.onPopupShowChange(false);
    },
    onCancel() {
      /**
       * 取消事件
       * @event cancel
       */
      this.$emit('cancel');
      this.onPopupShowChange(false);
    },
    onPopupShowChange(show) {
      /**
       * 弹框显示变化事件
       */
      this.$emit('change', show);
    },
  },
};
</script>
